import {combineReducers} from 'redux';

import notification from '@pluto/notification/Redux/NotificationReducer';
import users from '@pluto/users/Redux/UsersReducer';
import userDetails from '@pluto/users/Redux/UserReducer';
import user from '../../Login/Redux/LoginReducer';
import appNames from '../../AppName/Redux/ListReducer';
import appName from '../../AppName/Redux/EditReducer';
import devices from '../../AppName/Redux/DeviceReducer';

const rootStore = combineReducers({
    user,
    notification,
    users,
    userDetails,
    appNames,
    appName,
    devices,
});

export default rootStore;
